import { render, staticRenderFns } from "./StepSupervisorCollaborator.vue?vue&type=template&id=7dbc7351&scoped=true&"
import script from "./StepSupervisorCollaborator.vue?vue&type=script&lang=js&"
export * from "./StepSupervisorCollaborator.vue?vue&type=script&lang=js&"
import style0 from "./StepSupervisorCollaborator.vue?vue&type=style&index=0&id=7dbc7351&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dbc7351",
  null
  
)

export default component.exports